// EQM2050_R01 - 용수사용. 전력량 등록
import { defaultTqcDailyInspectionDto, TqcDailyInspectionDto } from "src/dtos/tqcDailyInspection/tqcDailyInspectionDto";

export interface EQM2050_R01Dto extends TqcDailyInspectionDto {
	listLength?: number;
	refetchListLength?: number;
	
	// 기본 정보
	compCd: string;					// 사업장
	compNm: string;					// 사업장명
	inspectionType: string;			// 점검유형
	inspectionDt: string;			// 사용일자 (yyyy-MM-dd 형식)
	dayOfWeek: string;				// 요일

	industrialWater: number;		// 산업용수 INDUSTRIAL_WATER inspectionType row 데이터
	domesticWater: number;			// 생활용수 DOMESTIC_WATER inspectionType row 데이터

	// 전력량 : ELECTRICAL_ENERGY inspectionType row 데이터
	electricalEnergy01: number;		// 옥상1
	electricalEnergy02: number;		// 옥상2
	electricalEnergy03: number;		// 옥상3

	remark: string;			// 비고

}

// 기본값 상수
export const defaultEQM2050_R01Dto: EQM2050_R01Dto = {
	...defaultTqcDailyInspectionDto,
	listLength: 0,
	refetchListLength: 0,
	
	compCd: '',
	compNm: '',
	inspectionType: '',
	inspectionDt: '',
	dayOfWeek: '',
	industrialWater: 0,
	domesticWater: 0,
	electricalEnergy01: 0,
	electricalEnergy02: 0,
	electricalEnergy03: 0,

	remark: '',

};

